export default "__VITE_ASSET__DMziGwTi__"